export class DeleteModal {

    constructor(callbackYes: Function, callbackNo: Function, callBackOk: Function) {
        this.callbackYes = callbackYes;
        this.callbackNo = callbackNo;
        this.callBackOk = callBackOk;
        this.showList=false;
    }

    toggle: boolean;
    message: string;
    callbackYes: Function;
    callbackNo: Function;
    callBackOk: Function;
    viewActionButtons: boolean;
      showList : boolean;
    list: any[];
}


// WEBPACK FOOTER //
// ./src/app/customerservice/models/delete-modal.ts